import $ from 'jquery';
import Backbone from 'backbone';


export default Backbone.View.extend({
  setup_collapsers: function () {
    // Buttons
    this.for_you = $('a.for-you', this.el);
    this.community = $('a.community', this.el);
    this.buttons = $(this.for_you).add(this.community);
    // One and only one element should be visible at a time
    this.buttons.on('click', function (e) {
      e.preventDefault();
      var target = $($(e.target).attr('data-target'));
      var sibling = target.siblings();
      if (sibling.height() === 0) {
        e.stopPropagation();
      } else {
        sibling.collapse('hide');
      }
    });

    // Change classes on collapsing "for you", "community"
    var self = this;
    $('.collapse', this.el).on('shown.bs.collapse', function (event) {
      self.buttons.toggleClass('active');
    });
  }
});



// WEBPACK FOOTER //
// ./static/js/views/yours_vs_community.js